// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oMsc","name":"styles_name__3ycJJ","phone":"styles_phone__2lPpl"};